import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../../common/chart/chartContainer/Line'
import { Legend } from '../../../../../../common/chart/legend'
import { Element } from '../../../../../../common/html/element'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../../helpers/common'
import {
  formatVal,
  isInValidValue,
  valToPercent,
} from '../../../../../../helpers/value'
import classes from '../../../index.module.scss'

const Chart = ({
  data,
  isCheckbox,
  checkboxs,
  checked,
  setChecked,
  title,
  style,
  isFooterUnder,
  isSmallXAxis,
  isEquityChart,
  isDynamicReport,
}) => {
  const chartId = useRef(getUnique())
  const locale = useSelector((state) => state.i18n.locale)
  const { formatedUnit, formatValueWithUnit, decimalLength } =
    useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)

  const bars = checkboxs.filter(
    (item) => item.isBarChart && checked.includes(item.value),
  )
  const groupStackBarKeys = bars.map((bar) => bar.value)

  const lines = checkboxs.filter(
    (item) => item.isLineChart && checked.includes(item.value),
  )

  const handleSetChecked = (checked) => {
    if (checkboxs.some((checkbox) => checked.includes(checkbox.value))) {
      setChecked(checked)
    }
  }

  const isNotHasBar = !bars.length

  return (
    <div
      style={style}
      className={`${isFooterUnder ? 'flexColumn' : 'dFlex'} h100`}
    >
      <Element
        className={`h100 flexColumn ${isFooterUnder ? 'w100' : 'w65'}`}
        style={{ minHeight: 180 }}
      >
        <div className="fw600">
          <Translate value={title} />
        </div>
        <Element className={`${classes.mt6}`} style={{ color: '#9C9C9C' }}>
          {!isNotHasBar ? formatedUnit : <>&nbsp;</>}
        </Element>
        <ChartContainer
          chartId={chartId.current}
          data={data}
          margin={{
            top: 16,
            bottom: 0,
            left: isNotHasBar || isDynamicReport ? 16 : 0,
            right: isDynamicReport ? 16 : 0,
          }}
          width="100%"
          height="100%"
          xAxis={[
            {
              dataKey: 'year',
              type: 'category',
              tickFormatter:
                isSmallXAxis && ((year) => '‘' + String(year).slice(2, 4)),
            },
          ]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: bars.map((item) => item.value),
              isStackedBar: true,
              hide: isNotHasBar,
              decimalLength,
            },
            {
              yAxisId: 'right',
              orientation: 'right',
              dataKeys: lines.map((item) => item.value),
              isLineChart: true,
              tickFormatter: (val) => formatVal(val, locale) + '%',
            },
          ]}
          tooltip={{
            schema: {
              content: [
                ...bars.map((bar) => ({
                  dataKey: bar.value,
                  label: bar.title,
                  formatValue: (value) => formatValueWithUnit({ value }),
                })),
                ...lines.map((line) => ({
                  dataKey: line.value,
                  label: line.title,
                  formatValue: (value) => valToPercent(value, locale, true),
                })),
              ],
            },
            position: isEquityChart ? { x: -10 } : undefined,
          }}
        >
          {bars.map((bar, barIndex) => (
            <Bar
              key={bar.value}
              yAxisId="left"
              dataKey={bar.value}
              fill={bar.color}
              isAnimationActive={false}
              stackId="stack"
              maxBarSize={25}
              showLabelEmpty={({ index }) =>
                barIndex === 0 &&
                groupStackBarKeys.every((dataKey) =>
                  isInValidValue(data[index][dataKey]),
                )
              }
            />
          ))}
          {lines.map((line) => (
            <Line
              key={line.value}
              yAxisId="right"
              dataKey={line.value}
              stroke={line.color}
              strokeWidth={2}
              isAnimationActive={false}
            />
          ))}
        </ChartContainer>
      </Element>
      <div
        className={`${
          isFooterUnder ? 'w100 py1' : 'h100 w35 px1'
        } dFlex alignItemsCenter ${
          !isDynamicReport ? 'justifyContentCenter' : ''
        }`}
      >
        <Legend
          chartId={chartId.current}
          items={checkboxs.map((item) => ({
            title: item.title,
            value: item.value,
            dataKey: item.value,
            color: item.color,
            isCheckbox: isCheckbox,
            listCheckBox: checked,
            setListCheckBox: handleSetChecked,
            isI18n: false,
            isDynamicReport: isDynamicReport,
          }))}
          className="flexColumn"
        />
      </div>
    </div>
  )
}

export default Chart
